import { Link } from 'react-router-dom';
import { categoryMeta, type CategorySlug } from '@/utils/movieUtils';

const order: CategorySlug[] = ['movie', 'series', 'short'];

export default function CategoryQuickLinks() {
  return (
    <section className="px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {order.map((slug, idx) => {
          const meta = categoryMeta[slug];
          return (
            <Link
              key={slug}
              to={`/category/${slug}`}
              className="group relative flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-400/60 hover:-translate-y-1"
            >
              <span
                className={`w-14 h-14 shrink-0 flex items-center justify-center rounded-lg text-2xl ${
                  idx === 1 ? 'bg-accent-500/15 text-accent-400' : 'bg-primary-500/15 text-primary-400'
                }`}
              >
                <i className={meta.icon}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-400 transition-colors">
                  {meta.label}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 line-clamp-2">{meta.desc}</p>
              </div>
              <i className="ri-arrow-right-line absolute right-5 text-foreground-500 group-hover:text-primary-400 group-hover:translate-x-1 transition-all"></i>
              <span className="absolute -bottom-6 -right-2 text-[80px] font-black text-background-200/70 select-none pointer-events-none font-heading">
                {meta.en}
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}